import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { GoldButton, ui } from "@/components/Primitives";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";

export function TField({ label, value, onChange, type = "text", placeholder = "", testid }) {
  return (
    <div>
      <Label className={ui.label}>{label}</Label>
      <Input data-testid={testid} type={type} value={value ?? ""} placeholder={placeholder}
        onChange={(e) => onChange(type === "number" ? e.target.value : e.target.value)}
        className={ui.input} />
    </div>
  );
}

export function TSelect({ label, value, onChange, options, testid }) {
  return (
    <div>
      <Label className={ui.label}>{label}</Label>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className={ui.selectTrigger}><SelectValue placeholder="Select" /></SelectTrigger>
        <SelectContent className={ui.selectContent}>
          {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

/** Schema-driven editor for embedded records (mortgage / insurance / manager). */
export function SchemaForm({ schema, initial, onSave, testidPrefix = "form" }) {
  const [state, setState] = useState(() => ({ ...initial }));
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setState((s) => ({ ...s, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const payload = {};
      schema.forEach((f) => {
        const v = state[f.key];
        payload[f.key] = f.type === "number" ? Number(v) || 0 : (v ?? "");
      });
      await onSave(payload);
      toast.success("Saved");
    } catch { toast.error("Could not save"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {schema.map((f) =>
          f.type === "select" ? (
            <TSelect key={f.key} label={f.label} value={state[f.key]} options={f.options}
              onChange={(v) => set(f.key, v)} testid={`${testidPrefix}-${f.key}`} />
          ) : (
            <TField key={f.key} label={f.label} value={state[f.key]} type={f.type || "text"}
              placeholder={f.placeholder} onChange={(v) => set(f.key, v)} testid={`${testidPrefix}-${f.key}`} />
          )
        )}
      </div>
      <div className="mt-6">
        <GoldButton data-testid={`${testidPrefix}-save`} onClick={save} disabled={saving}>
          {saving ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />} Save
        </GoldButton>
      </div>
    </div>
  );
}
